<script>

export default {
    name: 'NewIllustration',

    props: {
        /**
         * The name of the illustration.
         */
        name: {
            type: String,
            default: '',
        },
    },


    render(createElement) {
        const {
            name
        } = this;

        if (!name) {
            return null;
        }

        const Illustration = require(`./illustrations/${name}.svg`).default;

        return createElement(Illustration, {
            attrs: {
                viewBox: '0 0 48 48',
                width: 72,
                height: 72,
                fill: 'none',
                'data-qa': 'new-illustration-test-id'
            },
        });
    },
};
</script>
